angular.module('workflow.app')
.factory 'template', () ->

  # Private Methods

  _getMRSClientGroups = (clientGroups) ->
    clientGroups.filter (clientGroup) -> clientGroup.name.split(".")[0] == "MRS"

  return {
    filterWorkflowTemplatesByClientGroup: (workflowTemplates, clientGroups) ->
      # This is a hacky solution to an MRS problem under time pressure.
      # Since it is for one client only we have left this as it, but if we need to
      # extend this to support new clients, we should consider a significant redesign.
      mrsClientGroups = _getMRSClientGroups(clientGroups)
      clientGroupNames = mrsClientGroups.map (clientGroup) -> clientGroup.name.split(".")[1]

      return workflowTemplates.filter (template) ->
        if !clientGroupNames or clientGroupNames.length == 0
          return true
        templateName = template.name.toLowerCase()
        clientGroupNames.some (clientGroupName) -> templateName.indexOf(clientGroupName.toLowerCase()) >= 0
  }
